// import React from 'react';
// import './seamless_onboard.css';
// import leftImage from "../../../img/des_sec/seam_card_Left.svg"
// import card1 from "../../../img/des_sec/seam_card_1.svg"
// import card2 from "../../../img/des_sec/seam_card_2.svg"
// import card3 from "../../../img/des_sec/seam_card_3.svg"

// const SeamlessOnboarding = () => {
//   return (
//     <div className="onboarding-container-se">
//          <div className="blue-header-se">
//         <h1>Features</h1>
//       </div>
//       {/* Background image (half flex design) */}
//       <div className="background-image-se"></div>
      
//       <div className="content-wrapper-se">
//         {/* Left side - single illustration image */}
//         <div className="left-illustration-se">
//           <img src={leftImage} alt="Onboarding Illustration" />
//         </div>
        
//         {/* Right side content */}
//         <div className="right-content-se">
//           {/* Title */}
//           <h1 className="title-se">Seamless Onboarding</h1>
          
//           {/* Three card images stacked vertically */}
//           <div className="cards-stack-se">
//             <img src={card1} alt="Instant Aadhaar Verification" className="feature-card-se" />
//             <img src={card2} alt="Customizable Approval Workflows" className="feature-card-se" />
//             <img src={card3} alt="Integrated Agency Management" className="feature-card-se" />
//           </div>
          
          
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SeamlessOnboarding;

// import React from 'react';
// import './seamless_onboard.css';
// import leftImage from "../../../img/des_sec/Seamless Onboarding.svg"
// import card1 from "../../../img/des_sec/seam_card_1.svg"
// import card2 from "../../../img/des_sec/seam_card_2.svg"
// import card3 from "../../../img/des_sec/seam_card_3.svg"
// import { useRef } from 'react';

// const SeamlessOnboarding = () => {
//   const sliderRef = useRef(null);

//   const scrollLeft = () => {
//     if (sliderRef.current) {
//       sliderRef.current.scrollBy({ left: -200, behavior: 'smooth' });
//     }
//   };

//   const scrollRight = () => {
//     if (sliderRef.current) {
//       sliderRef.current.scrollBy({ left: 200, behavior: 'smooth' });
//     }
//   };

//   return (
//     <div className="onboarding-container-se">
//       <div className="blue-header-se">
//         <h1>Features</h1>
//       </div>
      
//       <div className="background-image-se"></div>
      
//       <div className="content-wrapper-se">
//         {/* Mobile title comes first */}
//         <h1 className="title-se mobile-title">Seamless Onboarding</h1>
        
//         {/* Left illustration */}
//         <div className="left-illustration-se">
//           <img src={leftImage} alt="Onboarding Illustration" />
//         </div>
        
//         {/* Right content */}
//         <div className="right-content-se">
//           {/* Desktop title (hidden on mobile) */}
//           <h1 className="title-se desktop-title">Seamless Onboarding</h1>
          
//           {/* Cards slider container */}
//           <div className="cards-slider-container">
//             <button className="slider-arrow left-arrow" onClick={scrollLeft}>&lt;</button>
            
//             {/* Cards stack with slider functionality */}
//             <div className="cards-stack-se" ref={sliderRef}>
//               <img src={card1} alt="Instant Aadhaar Verification" className="feature-card-se" />
//               <img src={card2} alt="Customizable Approval Workflows" className="feature-card-se" />
//               <img src={card3} alt="Integrated Agency Management" className="feature-card-se" />
//             </div>
            
//             <button className="slider-arrow right-arrow" onClick={scrollRight}>&gt;</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SeamlessOnboarding;


import React, { useRef, useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import './seamless_onboard.css';
import leftImage from "../../../img/des_sec/Seamless Onboarding.svg"
import card1 from "../../../img/des_sec/seam_card_1.svg"
import card2 from "../../../img/des_sec/seam_card_2.svg"
import card3 from "../../../img/des_sec/seam_card_3.svg"

const SeamlessOnboarding = () => {
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        } else {
          setInView(false);
        }
      },
      {
        threshold: 0.2,
        rootMargin: '-50px 0px'
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  // Animation for blue header
  const blueHeaderAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(-15px)',
    config: { 
      tension: 200, 
      friction: 40,
      mass: 1
    },
    delay: inView ? 100 : 0
  });

  // Animation for mobile title
  const mobileTitleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: { 
      tension: 180, 
      friction: 35,
      mass: 1
    },
    delay: inView ? 200 : 0
  });

  // Animation for left illustration
  const leftIllustrationAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-30px) scale(0.95)',
    config: { 
      tension: 160, 
      friction: 30,
      mass: 1.2
    },
    delay: inView ? 300 : 0
  });

  // Animation for desktop title
  const desktopTitleAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(20px)',
    config: { 
      tension: 180, 
      friction: 35,
      mass: 1
    },
    delay: inView ? 400 : 0
  });

  // Animation for left arrow
  const leftArrowAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px) scale(1)' : 'translateX(-10px) scale(0.9)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 500 : 0
  });

  // Animation for right arrow
  const rightArrowAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px) scale(1)' : 'translateX(10px) scale(0.9)',
    config: { 
      tension: 150, 
      friction: 25,
      mass: 0.8
    },
    delay: inView ? 500 : 0
  });

  // Individual card animations with staggered delays
  const card1Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
    config: { 
      tension: 140, 
      friction: 25,
      mass: 0.9
    },
    delay: inView ? 600 : 0
  });

  const card2Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
    config: { 
      tension: 140, 
      friction: 25,
      mass: 0.9
    },
    delay: inView ? 750 : 0
  });

  const card3Animation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.95)',
    config: { 
      tension: 140, 
      friction: 25,
      mass: 0.9
    },
    delay: inView ? 900 : 0
  });

  return (
    <div className="onboarding-container-se" ref={containerRef}>
      <animated.div 
        className="blue-header-se"
        style={{
          ...blueHeaderAnimation,
          position: 'relative',
          zIndex: 1
        }}
      >
        <h1>Features</h1>
      </animated.div>
      
      <div className="background-image-se"></div>
      
      <div className="content-wrapper-se">
        {/* Mobile title comes first */}
        <animated.h1 
          className="title-se mobile-title"
          style={{
            ...mobileTitleAnimation,
            position: 'relative',
            zIndex: 1
          }}
        >
          Seamless Onboarding
        </animated.h1>
        
        {/* Left illustration */}
        <animated.div 
          className="left-illustration-se"
          style={{
            ...leftIllustrationAnimation,
            position: 'relative',
            zIndex: 1
          }}
        >
          <img src={leftImage} alt="Onboarding Illustration" />
        </animated.div>
        
        {/* Right content */}
        <div className="right-content-se">
          {/* Desktop title (hidden on mobile) */}
          <animated.h1 
            className="title-se desktop-title"
            style={{
              ...desktopTitleAnimation,
              position: 'relative',
              zIndex: 1
            }}
          >
            Seamless Onboarding
          </animated.h1>
          
          {/* Cards slider container */}
          <div className="cards-slider-container">
            <animated.button 
              className="slider-arrow left-arrow" 
              onClick={scrollLeft}
              style={{
                ...leftArrowAnimation,
                position: 'relative',
                zIndex: 1
              }}
            >
              &lt;
            </animated.button>
            
            {/* Cards stack with slider functionality */}
            <div className="cards-stack-se" ref={sliderRef}>
              <animated.img 
                src={card1} 
                alt="Instant Aadhaar Verification" 
                className="feature-card-se"
                style={{
                  ...card1Animation,
                  position: 'relative',
                  zIndex: 1
                }}
              />
              <animated.img 
                src={card2} 
                alt="Customizable Approval Workflows" 
                className="feature-card-se"
                style={{
                  ...card2Animation,
                  position: 'relative',
                  zIndex: 1
                }}
              />
              <animated.img 
                src={card3} 
                alt="Integrated Agency Management" 
                className="feature-card-se"
                style={{
                  ...card3Animation,
                  position: 'relative',
                  zIndex: 1
                }}
              />
            </div>
            
            <animated.button 
              className="slider-arrow right-arrow" 
              onClick={scrollRight}
              style={{
                ...rightArrowAnimation,
                position: 'relative',
                zIndex: 1
              }}
            >
              &gt;
            </animated.button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeamlessOnboarding;